import { render } from "./GuestVlanNetworksTab.vue?vue&type=template&id=534c5587&scoped=true"
import script from "./GuestVlanNetworksTab.vue?vue&type=script&lang=js"
export * from "./GuestVlanNetworksTab.vue?vue&type=script&lang=js"

import "./GuestVlanNetworksTab.vue?vue&type=style&index=0&id=534c5587&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.20.2.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-534c5587"]])

export default __exports__